export interface Model {
  id: number
  name: string
  slug: string
  description: string
  base_price: number
  sqft: number
  sleeps: number
  bathrooms: number
  has_loft: number
  weight_limit: number | null
  image_url: string | null
  glb_url: string | null
  best_for: string | null
  is_active: number
  sort_order: number
}

export interface Category {
  id: number
  name: string
  slug: string
  description: string
  selection_type: string
  is_required: number
  is_active: number
  sort_order: number
}

export interface Option {
  id: number
  category_id: number
  name: string
  slug: string
  description: string
  price: number
  weight_impact: number
  image_url: string | null
  layer_image_url: string | null
  is_active: number
  sort_order: number
}

export interface ModelOption {
  model_id: number
  option_id: number
}

export interface Constraint {
  id: number
  constraint_type: string
  source_type: string
  source_id: number
  target_type: string
  target_id: number
  message: string
  severity: string
  is_active: number
}

export interface PublicConfig {
  models: Model[]
  categories: Category[]
  options: Option[]
  model_options: ModelOption[]
  constraints: Constraint[]
  settings: Record<string, string>
}

export interface Lead {
  id: number
  customer_name: string
  email: string
  phone: string
  location: string | null
  timeline: string | null
  budget_range: string | null
  financing_interest: number
  contact_method: string | null
  selected_model_id: number | null
  selected_model_name_snapshot: string
  base_price_snapshot: number
  estimated_total_snapshot: number
  disclaimer_snapshot: string
  disclaimer_version: string
  terms_accepted_at: string
  pricing_valid_until_snapshot: string | null
  notes: string | null
  admin_notes: string | null
  status: string
  pdf_url: string | null
  created_at: string
  updated_at: string
}

export interface LeadOption {
  id: number
  lead_id: number
  option_id: number | null
  option_name_snapshot: string
  category_name_snapshot: string
  option_price_snapshot: number
}

export interface ConstraintResult {
  warnings: Array<{ message: string; optionId?: number }>
  blockers: Array<{ message: string; optionId?: number }>
  disabled: number[]
  autoAdd: number[]
  autoRemove: number[]
}

export type BuildStep = 'landing' | 'model' | 'customize' | 'review' | 'form' | 'thanks'

export interface CustomerDraft {
  name: string
  email: string
  phone: string
  location: string
  timeline: string
  budget_range: string
  financing_interest: boolean
  contact_method: string
  notes: string
}

export const LEAD_STATUSES = [
  { value: 'new',           label: 'New' },
  { value: 'reviewed',      label: 'Reviewed' },
  { value: 'contacted',     label: 'Contacted' },
  { value: 'estimate_sent', label: 'Estimate Sent' },
  { value: 'deposit_paid',  label: 'Deposit Paid' },
  { value: 'construction',  label: 'Construction' },
  { value: 'won',           label: 'Won' },
  { value: 'lost',          label: 'Lost' },
  { value: 'archived',      label: 'Archived' },
] as const
